import React from "react";
import AnimationBanner from "../components/AnimationBanner/AnimationBanner";
import Furniture from "../components/furnitureThree/Furniture";
import SavoirFaire from "../components/SavoirFaire/SavoirFaire";
import HomeScreen from "../screens/HomeScreen";
//
//

//
//
const Home = () => {
  return (
    <>
      {" "}
      <AnimationBanner />
      <Furniture />
      <HomeScreen />
      <SavoirFaire />
    </>
  );
};

export default Home;
